<template>
  <div class="loading-box rounded-full border border-grey-925">
    <div class="loader rounded-full"></div>
  </div>
</template>

<script setup lang="ts"></script>

<style>
.loading-box {
  position: relative;
  overflow: hidden;
  height: 1rem;
}
.loader {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #000091;
  left: -100%;
  animation: load 3s linear infinite;
}

@keyframes load {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>
